import { useEffect } from "react";

export function useAutosizeTextarea(
  ref: React.RefObject<HTMLTextAreaElement>,
  value: string
) {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    el.style.height = "auto";
    el.style.height = el.scrollHeight + "px";
  }, [value]);
}
